import { render } from "./SettingNotification.vue?vue&type=template&id=dc1da716&scoped=true"
import script from "./SettingNotification.vue?vue&type=script&lang=js"
export * from "./SettingNotification.vue?vue&type=script&lang=js"

import "./SettingNotification.vue?vue&type=style&index=0&id=dc1da716&scoped=true&lang=scss"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1da716"]])

export default __exports__